import Human from './human.js';
import App from '../App.js';

export default function sketch(p) {

    let addData;
    let clearData;

    let humans = [];
    let canvas;

    let r = 6;
    let minDistanceToBorder = 10;

    let speed1 = 1;
    let speed2 = 2;
    let percentageSpeed1 = 0.5;

    let count = 200;
    let maxSpeed = 20;

    let infectionRate = 0.5;
    let infectionDuration; //seconds
    let morality = 0.9;

    let width;
    let height;

    let started;
    let drawText = true;
    let frame = 0;

    let frameRate = 55;
    let frameNumber = 2;

    p.setup = () => {
        frame = 0;
        if (clearData !== undefined) clearData();
        width = p.windowWidth - 50;
        height = p.windowHeight - 50;
        if (App.canvasWidth && App.canvasHeight) {
            width = App.canvasWidth;
            height = App.canvasHeight;
        }

        canvas = p.createCanvas(width, height);
        p.noStroke();

        initHumans();

        selectFirstInfectedPersonRandomly();

        setSpeed();

        p.frameRate(frameRate);
    }

    p.draw = () => {
        if (started) {
            p.background('rgb(100%,100%,100%)');
            frame++;
            if (isAnybodyInfected()) {
                if (frame % frameRate === 0) updateGraph();

                for (let human of humans) {
                    human.update();

                    for (let otherHuman of humans) {
                        if (human === otherHuman) { }
                        else if (human.position.copy().add(human.velocity).dist(otherHuman.position.copy().add(otherHuman.velocity)) > r * 2) { }
                        else {
                            if (otherHuman !== undefined) human.turn(otherHuman);
                        }
                    }
                }
            } else {
                started = false;
                updateGraph();
                frameNumber = 2;
            }
            for (let human of humans) {
                human.show();
            }
        }
        else {
            if (drawText) {
                p.fill(0);
                p.translate(width / 2, height / 2);
                p.textSize(32);
                let text = 'Simulation starten';
                p.text(text, p.textWidth(text) / -2, -16);
                drawText = false;
            }
        }
    }

    p.windowResized = () => {
        if (App.canvasWidth && App.canvasHeight) {
            p.resizeCanvas(App.canvasWidth, App.canvasHeight);
        }
    }

    p.myCustomRedrawAccordingToNewPropsHandler = (newProps) => {
        if (canvas) { //Make sure the canvas has been created

            if (newProps.started !== started) {
                let settings = newProps.settings;
                percentageSpeed1 = settings.percent1 / 100;
                speed1 = settings.speed1 / 100 * maxSpeed;
                speed2 = settings.speed2 / 100 * maxSpeed;

                count = settings.amount;
                infectionRate = settings.infectionRate / 100;
                infectionDuration = settings.time; //seconds
                morality = settings.mortality / 100;

                if (newProps.started !== undefined) {
                    started = newProps.started;
                    addData = newProps.addData;
                    clearData = newProps.clearData;
                }
                frameNumber = 2;
                p.setup();
                drawText = true;
            }

        }
    }

    function updateGraph() {
        let values = new Map();

        values.set(0, 0);
        values.set(1, 0);
        values.set(2, 0);
        values.set(3, 0);

        humans.forEach(human => {
            values.set(human.state, values.get(human.state) + 1);
        });
        addData({ healthy: values.get(0), infected: values.get(1), dead: values.get(3), recovered: values.get(2), number: frameNumber++ });
    }

    function shuffle(array) {
        var currentIndex = array.length, temporaryValue, randomIndex;

        // While there remain elements to shuffle...
        while (0 !== currentIndex) {

            // Pick a remaining element...
            randomIndex = Math.floor(Math.random() * currentIndex);
            currentIndex -= 1;

            // And swap it with the current element.
            temporaryValue = array[currentIndex];
            array[currentIndex] = array[randomIndex];
            array[randomIndex] = temporaryValue;
        }

        return array;
    }

    function setSpeed() {
        let numberOfHumansWithSpeed1 = count * percentageSpeed1;
        shuffle(humans);
        humans.forEach((human, index) => {
            human.setSpeed(index < numberOfHumansWithSpeed1 ? speed1 : speed2);
        });
    }

    function selectFirstInfectedPersonRandomly() {
        let randIndex = Math.floor((Math.random() * humans.length));
        humans[randIndex].state = 1;
    }

    function initHumans() {
        humans = [];
        let rows = Math.ceil(Math.sqrt(count));
        let cols = rows;

        let rowHeight = height / rows;
        let colWidth = width / cols;

        //create Humans - normally more than the count
        for (let col = 0; col < cols; col++) {
            for (let row = 0; row < rows; row++) {
                let x = (col * colWidth) + (((Math.random() * 0.8) + 0.1) * colWidth);
                let y = (row * rowHeight) + (((Math.random() * 0.8) + 0.1) * rowHeight);
                x = Math.min(Math.max(r + minDistanceToBorder, x), width - r - minDistanceToBorder);
                y = Math.min(Math.max(r + minDistanceToBorder, y), height - r - minDistanceToBorder);
                humans.push(new Human(p, x, y, r, width, height, infectionRate, infectionDuration, morality));
            }
        }

        //delete randomly humans until humans.lenght <= count
        while (humans.length > count) {
            let randIndex = Math.floor((Math.random() * humans.length));
            humans.splice(randIndex, 1);
        }
    }

    function isAnybodyInfected() {
        return humans.some(human => human.state === 1);
    }
}